import { Component, EventEmitter, inject, input, Input, output, Output, signal } from '@angular/core';
import { VideoFormatEnum } from '../../../../common/general-types/briefs.dto';
import { VideoResponseDto, VideoStatusEnum } from '../../../../common/general-types/videos.dto';
import { S3uploaderService } from '../../../../services/s3uploader/s3uploader.service';
import { FormatService } from '../../../../common/format/format.service';
import { TooltipDirective } from '../../../../common/directives/tooltip/tooltip.directive';
import { ViewSubManageService } from '../../services/view-sub-manage/view-sub-manage.service';
import { VideoAiModerateService } from '../../../../services/video-ai-moderate/video-ai-moderate.service';
import { VideoThumbnailComponent } from '../../../../atoms/video-thumbnail/video-thumbnail.component';
import { VideoService } from '../../../../services/video/video.service';
import { finalize } from 'rxjs';
import { AdLicenseDto, AdLicenseQuoteDto, AdLicenseSlotState } from '../../../../common/general-types/ad-license.dto';
import { resolveAdLicenseSlot } from '../../../../services/ad-license/ad-license-state';
import { AdLicenseSlot } from '../ad-license-slot/ad-license-slot';
import { HasRoleDirectiveDirective } from '../../../../common/directives/has-role/has-role-directive.directive';

@Component({
  selector: 'vs-draft-item-thumb',
  standalone: true,
  imports: [TooltipDirective, VideoThumbnailComponent, AdLicenseSlot, HasRoleDirectiveDirective],
  templateUrl: './draft-item-thumb.component.html',
  styleUrl: './draft-item-thumb.component.css'
})
export class DraftItemThumbComponent {

  @Input() video!: VideoResponseDto;
  @Input() videoFormat!: VideoFormatEnum;
  @Output() showVideoFeedback = new EventEmitter<VideoResponseDto>();
  @Output() videoApproved = new EventEmitter<boolean>();

  /** Ad License: the quote for this application (null hides the licence slot). */
  readonly licenseQuote = input<AdLicenseQuoteDto | null>(null);
  /** Ad License: the latest licence for this video, if any. */
  readonly license = input<AdLicenseDto | null | undefined>(null);
  readonly buyLicense = output<VideoResponseDto>();
  readonly cancelLicense = output<AdLicenseDto>();

  approvingVideo = signal<boolean>(false);

  /** App */

  VideoStatusEnum = VideoStatusEnum;

  /** Services */
  public uploadService = inject(S3uploaderService);
  public formatService = inject(FormatService);
  public viewSubManageService = inject(ViewSubManageService);
  public videoAiModerateService = inject(VideoAiModerateService);
  public videoService = inject(VideoService);
  /** Services - END */


  async downloadContent() {
    if (this.video ) {
      if (this.video.fullUrl.includes('firebasestorage.googleapis.com')) {
        this.uploadService.progressFirebaseDownload(this.video.fullUrl);
      } else {
        this.uploadService.secureVideoDownload(this.video.fullUrl, this.video.videoName);
      }
    }
  }

  triggerVideoApproval(video: VideoResponseDto) {
    console.log('🤢🤢🤢 Trigger Video Approval()', video);
    this.approvingVideo.set(true);
    void this.videoService
      .approveVideoModern(video.id, this.video.briefId ?? '')
      .pipe(finalize(() => this.approvingVideo.set(false)))
      .subscribe({
        next: (response: unknown) => {
          console.log('🤢🤢🤢 Approve Video Response: ', response);
          this.video.status = VideoStatusEnum.Accepted;
          this.viewSubManageService.approvedVideos.update(existing => [...(existing ?? []), video]);
          this.videoApproved.emit(true);
        },
        error: error => {
          console.error('Error approving video:', error);
          this.videoApproved.emit(false);
        }
      });
  }


  /** `video` is a mutable decorator input (approval flips its status in place), so this stays a method. */
  licenseSlot(): AdLicenseSlotState {
    return resolveAdLicenseSlot(this.video?.status, this.licenseQuote(), this.license());
  }

  onBuyLicense(): void {
    this.buyLicense.emit(this.video);
  }

  onCancelLicense(): void {
    const license = this.license();
    if (license) this.cancelLicense.emit(license);
  }

  cancelApprovalProcess() {

  }

  openViewer(event: any) {
    this.showVideoFeedback.emit(this.video);
  }

  getModerateScoreClass(score: number) {
    if (score < 25) {
      return "bg-red-50 dark:bg-red-900/30 text-red-700 ring-red-600 ring-red-20"
    } else if (score < 50) {
      return "bg-orange-50 dark:bg-orange-900/30 text-orange-700 ring-orange-600 ring-orange-20"
    } else if (score < 70) {
      return "bg-sky-50 dark:bg-sky-900/30 text-sky-700 ring-sky-600 ring-sky-20"
    } else {
      return "bg-green-50 dark:bg-green-900/30 text-green-700 ring-green-600 ring-green-20"
    }
  }
}
